import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import userReducer from './features/user/userSlice';
import cartReducer from './features/cart/cartSlice';
import couponReducer from './features/cart/couponSlice';
import recentlyViewedReducer from './features/product/recentlyViewedSlice';
import orderReducer from './features/order/orderSlice';
import authReducer from './features/auth/authSlice';
import mandateReducer from './features/paystack/mandateSlice';
import deliveryReducer from './features/order/deliveryAddressSlice';
import fullPaymentReducer from './features/order/fullPaymentSlice';
import backendDeliveryFeeReducer from './features/order/backendDeliveryFeeSlice';
import addressVerificationReducer from './features/user/verificationSlices/addressVerifcationSlice';
import debtVerificationReducer from './features/user/verificationSlices/debtVerificationSlice';
import staySmallSmallRecentlyViewedReducer from './features/staySmallSmall/staySmallSmallRecentlyViewed';
import rentSmallSmallRecentlyViewedReducer from './features/rentSmallSmall/rentSmallSmallRecentlyViewed';
import staySmallSmallBookingDataReducer from './features/staySmallSmall/staySmallSmallBookingData';
import staySmallSmallUpdatedBookingDataReducer from './features/staySmallSmall/staySmallSmallUpdatedBookingData';

const appReducer = combineReducers({
  user: userReducer,
  cart: cartReducer,
  recentlyViewed: recentlyViewedReducer,
  order: orderReducer,
  delivery: deliveryReducer,
  backendDeliveryFee: backendDeliveryFeeReducer,
  auth: authReducer,
  mandate: mandateReducer,
  fullPayment: fullPaymentReducer,
  addressVerification: addressVerificationReducer,
  debtVerification: debtVerificationReducer,
  staySmallSmallRecentlyViewed: staySmallSmallRecentlyViewedReducer,
  rentSmallSmallRecentlyViewed: rentSmallSmallRecentlyViewedReducer,
  staySmallSmallBookingData: staySmallSmallBookingDataReducer,
  staySmallSmallUpdatedBookingData: staySmallSmallUpdatedBookingDataReducer,
  coupon: couponReducer,
});

//  Root reducer that resets everything on LOGOUT
const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined; // completely reset Redux state
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'cart',
    'user',
    'recentlyViewed',
    'order',
    'delivery',
    'backendDeliveryFee',
    'auth',
    'mandate',
    'fullPayment',
    'addressVerification',
    'debtVerification',
    'staySmallSmallRecentlyViewed',
    'rentSmallSmallRecentlyViewed',
    'staySmallSmallBookingData',
    'staySmallSmallUpdatedBookingData',
    'coupon',
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
